import { createRequestTypes } from '../../utils';

export const LOAD_MODAL_DATA = createRequestTypes('shadeXInciModal/LOAD_MODAL_DATA');